export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";